import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import PulseOnShip1 from 'assets/Home/portfolio/pulseonship1.avif'
import PulseOnShip2 from 'assets/Home/portfolio/pulseonship2.avif'
import PulseOnShip3 from 'assets/Home/portfolio/pulseonship3.avif'
import PulseOnShip4 from 'assets/Home/portfolio/pulseonship4.avif'

const PusleOnShip = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)

    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    물류 견적 페이지
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    원하는 물류 견적 옵션을 선택한 뒤,{!isTablet && <br />}
                    해당 물류에 대한 간편견적 또는 상세견적으로{!isTablet && <br />}
                    스마트한 물류를 시작해보세요
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    견적요청을 통해 내가 입력한 물류 정보에 대한 견적을 받을 수 있으며,{!isTablet && <br />}
                    해당 요청사항을 선택해 완료하실 경우 물류에 대한 배송 상황 및 상태를{!isTablet && <br />}
                    견적현황 페이지를 통해 상세하게 알 수 있습니다.
                </motion.h4>

                <motion.img
                    src={PulseOnShip1}
                    alt="PulseOnShip1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    물류관리 및 트래킹
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    펄스온쉽 관리자 페이지를 통해{!isTablet && <br />}
                    고객님의 물류 운송을 트래킹 정보부터{!isTablet && <br />}
                    통관 및 리스크까지 심층 관리합니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    고객님의 물류 운송에 대한 모든 절차를 확인하고{!isTablet && <br />}
                    리스크 발생시 즉각적으로 상황보고 및 대응이 가능합니다.
                </motion.h4>

                <motion.img
                    src={PulseOnShip2}
                    alt="PulseOnShip2"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    서브계정과 사후관리
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    대표계정을 통해 서브계정을 생성 및 관리 할 수 있습니다.{!isTablet && <br />}
                    서브계정을 이용하여 업무 부담을 체계화 하고{!isTablet && <br />}
                    사후관리를 통해 서류 작업 및 창고 재고 관리가 가능합니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    고객님의 물류 운송에 대한 모든 절차를 확인하고{!isTablet && <br />}
                    리스크 발생시 즉각적으로 상황보고 및 대응이 가능합니다.
                </motion.h4>

                <motion.img
                    src={PulseOnShip3}
                    alt="PulseOnShip3"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    통합 관리자 시스템
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    관리자는 통합관리시스템을 통해{!isTablet && <br />}
                    유저, 물류 관리, 이벤트등에 대한 관리를{!isTablet && <br />}
                    한눈에 처리하실 수 있습니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    펄스온쉽 솔루션을 자사 컨설팅 프로그램으로써 사용하실 때,{!isTablet && <br />}
                    전체 물류 관리, 리스크 관리, 서류 관리 및 사용자 관리 등{!isTablet && <br />}
                    종합 물류 서비스를 한 눈에 관리하실 수 있습니다.
                </motion.h4>

                <motion.img
                    src={PulseOnShip4}
                    alt="PulseOnShip4"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default PusleOnShip
